
// define adlinker function that will be called and defined as a global variable
adlinker_client_function = function(){

	let url = new URL(window.location.href);
  	let config = {};

  	//default config
	let doms = ['beistravel.com','www.kalkstore.com','drnxmyth.com'];
	if(doms.includes(url.host)){
	//if(url.host == 'beistravel.com'){
		config.enable_url_param = false;
	}else{
   		config.enable_url_param = true;
	}
	//config.enable_url_param = true;
	config.stage = 'prod';
  	config.initialized = false;
	config.script_src = document.currentScript.src;
  	config.page_key = 'al_pg_id';
	config.cookie_key = 'al_br_id';

	if(Shopify){config.platform = 'shopify'}

	let data = {};
	data.ua = navigator.userAgent;
	data.requested_url = url.href;
	if(!document.referrer.includes(url.hostname)){data.referrer_url = document.referrer};
	if(get_cookie(config.cookie_key)){data.cookie = get_cookie(config.cookie_key)};

	function configure(params = {}){
		if(params.enable_url_param != undefined){config.enable_url_param = params.enable_url_param;}
		if(params.stage != undefined){config.stage = params.stage;}
	}

	// starting adlinker()
	function initialize(){
		fetch('https://api.ipify.org?format=json')
		.then(response => response.json())
		.then(function(json){
			data.ip = json.ip;

			url.href = config.script_src;
			config.origin = url.origin;

			if(config.enable_url_param){persist_url_params()};
			if(config.platform == 'shopify'){shopify()};

			config.initialized = true; // now initialized
			send_data({event:{type:'pageview'}});
		});
	}

	function set_params(){ // set params on current url var
		if(get_cookie(config.cookie_key)){
			url.href = window.location.href;
			data.cookie = get_cookie(config.cookie_key);
			url.searchParams.set(config.page_key, data.cookie); // set browser id in page
			window.history.replaceState(null,null,url.href); // reset state
		}
	}


	// this decorates window.location (current url)
	function persist_url_params(){
		window.addEventListener('load',function(){
			set_params(); // call the function just defined to set params
			document.addEventListener('change', function(){ // and call the function again if the DOM changes at all
				url.href = window.location.href; // set url var to current href
				if(!url.searchParams.has(config.page_key)){ //only reset url if page id not found in url
					set_params(); // set params again
				}
			});
		});
	}

	//utility function to grab a cookie value
	function get_cookie(cookie){
		let cart_regex = "\ " + cookie + "=[^;]*(?=;|$)"; //this regex matches specific cookie in cookie string
		let match = document.cookie.match(cart_regex)
		return (match ? match[0].replace(' ' + cookie + '=','') : null); // if there's a match, grab the first one
	}

	function shopify(){
		let cart = get_cookie('cart');
		if(cart){data.shopify_cart = cart};
		window.addEventListener('click',function(){
			var cartFinder = setInterval(function(){
				if(cart != get_cookie('cart')){
					cart = get_cookie('cart');
					if(cart){
						data.shopify_cart = cart;
						send_data({event:{type:"microdata"}});
					}
					//console.log(data.shopify_cart); //doing this until further notice
					clearInterval(cartFinder);
				}
			}, 100);
			setTimeout(() => clearInterval(cartFinder), 2000);
		});
		if(Shopify.checkout){
			data.shopify_purchase_id = Shopify.checkout.order_id.toString();
//			if(Shopify.checkout.email){data.email = Shopify.checkout.email};
//			if(Shopify.checkout.phone){data.phone = Shopify.checkout.phone};
//			data.shopify_customer_id = Shopify.checkout.customer_id.toString();
		}
	}

    // log function for debugging
	function log_vars(){
		// recheck until initialized is true
		let inter = setInterval(function(){
			if(config.initialized){
				// once initialized, clear the interval
				clearInterval(inter);
				// log vars
				console.log('adlinker data:');
				console.log(data);
				console.log('adlinker config:');
				console.log(config);
			}
		},100);
	}

	// send event function
	// event argument should contain event data as needed - see schema above
	// user can contain user data following schema above, but not necessary
	function send_data(args = {}){
		if (args.event === undefined){args.event = {}}
		if (args.email !== undefined){data.email = args.email}
		let endpoint = [config.origin, config.stage, 'js-api'].join('/');
		var xhr = new XMLHttpRequest();
		xhr.open("POST", endpoint);
		xhr.withCredentials = true;
		//xhr.setRequestHeader('content-type','application/json');
		xhr.onreadystatechange = function(){
			if(this.readyState === XMLHttpRequest.DONE && this.status === 200){
				if(config.enable_url_param){set_params();}
			}
		}

		function send() {
			let payload = {};
			payload.data = data;
			payload.event = args.event;
			xhr.send(JSON.stringify(payload));
		}

		if(!config.initialized){
			let inter = setInterval(function(){
				if(config.initialized){
					clearInterval(inter);
					send();
				}
			},100);
		}else{
			send();
		}
	}

	return{
		config:configure,
		init:initialize,
		send:send_data,
		log:log_vars,
		cookie:get_cookie
	}
}


var adlinker = adlinker_client_function();
if (typeof adlinker_config != 'undefined'){
	adlinker.config(adlinker_config);
	adlinker.init();
}else{
	adlinker.init();
}